import { React, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import styled from 'styled-components'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import { useDispatch } from 'react-redux'
import useToast from 'hooks/useToast'

import SearchBar from './SearchBar'
import AnalyzedTopicList from './AnalyzedTopicList'
import DashboardList from './DashboardList'
import { getRecentRecords, getTopicInfos } from '../../features/home/asyncThunks'

const StyledMain = styled.main`
  padding: 0px 30px;
  display: flex;
  flex-direction: column;
`

const StyledDiv = styled.div`
  display: flex;
  justify-content: space-evenly;
`

const Jumbotron = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
  flex-direction: column;
`

const StyledButton = styled.button`
  width: fit-content;
  margin: 16px;
`

const Home = () => {
  const dispatch = useDispatch()
  const [addToast] = useToast()

  useEffect(() => {
    dispatch(getRecentRecords())
    dispatch(getTopicInfos())
  }, [dispatch])

  const navigate = useNavigate()

  return (
    <>
      <StyledMain>
        <Jumbotron>
          <Typography variant="h4" component="div">
            Search
          </Typography>
          <SearchBar />
        </Jumbotron>
        <Divider variant="middle" />
        <StyledDiv>
          <DashboardList />
          <AnalyzedTopicList />
        </StyledDiv>
        <div>
          <div>Temp Demo Area</div>
          <Divider variant="middle" />
          <div>
            <StyledButton
              type="button"
              onClick={() => {
                addToast({ toastId: 'ohGG', type: 'warning', message: 'non duplicateable' })
              }}>
              non duplicateable toast
            </StyledButton>
            <StyledButton
              type="button"
              onClick={() => {
                addToast({
                  message: (
                    <div>
                      sdfsdf
                      <button type="button" style={{ marginLeft: '8px' }}>
                        learn more
                      </button>
                    </div>
                  )
                })
              }}>
              normal toast
            </StyledButton>
            <StyledButton
              type="button"
              onClick={() => {
                navigate('/system-message-live-report', {
                  state: { errorCode: 'notAvailable', user: 'Vincent' }
                })
              }}>
              navigate to system message
            </StyledButton>
          </div>
        </div>
      </StyledMain>
    </>
  )
}

export default Home
